import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RepresentacaoInstituicaoGestora } from '../models/representacao-instituicao-gestora.model';
import { RepresentacaoInstituicaoGestoraRedefinirSenha } from '../models/representacao-instituicao-gestora-redefinirSenha.model';

@Injectable({
  providedIn: 'root'
})
export class RepresentacaoInstituicaoGestoraService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  // List all RepresentacaoInstituicaoGestora
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: RepresentacaoInstituicaoGestora[] }>(`${this.path}/getAllRepresentacaoInstituicaoGestora`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get RepresentacaoInstituicaoGestora by ID
  public show(id: string): Observable<RepresentacaoInstituicaoGestora> {
    return this.apiService.get<{ data: RepresentacaoInstituicaoGestora }>(`${this.path}/getRepresentacaoInstituicaoGestoraById/${id}`).pipe(
      map(response => response.data)
    );
  }

  /* Create new RepresentacaoInstituicaoGestora
  public store(data: FormData): Observable<any> {
    return this.apiService.post<any>(
      `${this.path}/AddRepresentacaoInstituicaoGestora`,
      data,
      {},  // ou `undefined` se seu ApiService não exigir esse parâmetro
    );
  }*/

  // Método para criar um novo representante (usando FormData)
  public store(data: FormData): Observable<any> {
    return this.apiService.post<any>(
      `${this.path}/AddRepresentacaoInstituicaoGestora`,
      data,
      {}  // ou undefined se seu ApiService não exigir esse parâmetro
    );
  }

  /* Create new RepresentacaoInstituicaoEnsinoRange
  public storeRange(representacaoInstituicaoGestora: RepresentacaoInstituicaoGestora): Observable<RepresentacaoInstituicaoGestora> {
    return this.apiService
      .post<{ object: RepresentacaoInstituicaoGestora }>(`${this.path}/AddRepresentacaoInstituicaoGestoraRange`, representacaoInstituicaoGestora)
      .pipe(
        map(response => response.object)
      );
  }*/

  public storeRange(representacoes: RepresentacaoInstituicaoGestora[]): Observable<any> {
    return this.apiService
      .post(`${this.path}/AddRepresentacaoInstituicaoGestoraRange`, representacoes);
  }


  // Update existing RepresentacaoInstituicaoGestora
  public update(formData: FormData, id: string): Observable<RepresentacaoInstituicaoGestora> {
    return this.apiService
      .put(`${this.path}/UpdateRepresentacaoInstituicaoGestora`, formData)
  }

  // Delete existing RepresentacaoInstituicaoGestora
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteRepresentacaoInstituicaoGestoraById/${id}`);
  }

  redefinirSenha(data: RepresentacaoInstituicaoGestoraRedefinirSenha): Observable<any> {
    const params = new HttpParams()
      .set('username', data.username)
      .set('email', data.email)
      .set('novasenha', data.novasenha);

    // Passa corpo vazio {} e o objeto options com 'params' (HttpParams)
    return this.apiService.post<any>(
      `${this.path}/Redefinir`,
      {},        // corpo vazio igual ao curl -d ''
      { params } // passa os parâmetros como query string
    );
  }

  /* Create new Representante com imagem
  public storeWithLogo(data: FormData): Observable<any> {
    return this.apiService.post<any>(
      `${this.path}/AddRepresentacaoInstituicaoGestora`,
      data,
      {},  // ou `undefined` se seu ApiService não exigir esse parâmetro
    );
  } */

  getFotoRepresentacaoInstituicaoGestoraById(id: number): Observable<Blob> {
    return this.apiService.get(`${this.path}/GetRepresentacaoInstituicaoGestoraLogotipoById/${id}`,
      new HttpParams(),
      false,
      'blob',
    );
  }
}
